module.exports = __webpack_public_path__ + "img/purple-graph.a853a4b5.png";